import { PokemonFooter, Text } from "../components/styles/pokemon.styles";

const PokemonBookFooter = () => {
  return (
    <PokemonFooter>
      <Text>상업적 목적이 아닌 개인 포트폴리오용으로 제작되었습니다.</Text>
    </PokemonFooter>
  );
};

export default PokemonBookFooter;
